import {
  Box,
  CircularProgress,
  Modal,
  Stack,
  IconButton,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useThemePalette } from "common/hooks/theme_palette";
import Loading from "components/Atoms/SharedComponents/Loading/Loading";
import AddLocation from "components/Molecules/Products/Variants/addLocation/addLocation";
import FormHeader from "components/Molecules/Products/Variants/formHeader";
import VariantDetailsForm from "components/Molecules/Products/Variants/variantDetailsForm";
import CustomTabs from "components/Organisms/tabs/customTabs";
import { useFormik } from "formik";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { removeDuplicateObjects } from "services/modules/utils/Helper";
import setAuthToken from "services/modules/utils/handel_api";
import {
  initialValues,
  structure,
  validationSchema,
} from "templates/products/productVariant/sturcture";

export default function VariantForm({
  open,
  id,
  details,
  optionTypesFilter = [],
  handleSubmit,
  locations,
  setLocations,
  handleVariantFormClose,
  handleSaveVariantBranch,
  handleDeleteVariantBranch,
  branches,
  fetchOptionValues,
  option_values,
  option_values_loading,
}) {
  const { t } = useTranslation();
  const token = localStorage.getItem("token");
  setAuthToken(token);

  const { oliveGreen } = useThemePalette();
  const load = useSelector((state) => state.products.variants_loading);

  const [selectedTab, setSelectedTab] = useState(0);
  const refsubmit = useRef();
  const navigate = useNavigate();

  const style = {
    position: "absolute",
    top: selectedTab == 0 ? "50%" : "30%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { xs: "95%", sm: 650 },
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: "8px",
    overflow: "hidden",
    minHeight: { xs: "90vh", sm: 500 },
    maxHeight: "95vh",
    display: "flex",
    flexDirection: "column",
  };

  const formik = useFormik({
    initialValues: !id ? {} : initialValues(details, optionTypesFilter),
    validationSchema: validationSchema(optionTypesFilter, t),
    onSubmit: async (values) => {
      handleSubmit(values, formik);
    },
    enableReinitialize: true,
    validateOnChange: false,
    validateOnBlur: false,
  });

  const handleClose = () => {
    formik.resetForm();
    handleVariantFormClose();
    setSelectedTab(0);
  };

  const handleAddAnotherLocation = () => {
    setLocations([...locations, { city: { id: 0 }, count_on_hand: 0 }]);
  };

  const handleLocationDataChange = (i, key, value) => {
    const newLocations = locations.map((loc, index) => {
      if (i === index) {
        if (key == "city") {
          return {
            ...loc,
            city: {
              id: value,
            },
          };
        } else if (key == "quantity") {
          return {
            ...loc,
            count_on_hand: value,
          };
        }
      } else {
        return loc;
      }
    });
    setLocations(newLocations);
  };

  const prepareOptionTypes = () => {
    let optionTypes = [];

    optionTypes = optionTypesFilter?.map((option) => {
      let options = option_values[option?.id]?.list || [];
      let values = details?.option_values || [];
      console.log("🚀 ~ prepareOptionTypes ~ options:", options, values);
      if (id) {
        // for default values when editing
        //without this we will not have initial value for the Cselect to select from
        options = [
          ...options,
          ...values?.filter((opt) => opt?.option_type_id == option.id),
        ];
        // because we set initial values, and then fetch when we open the ddl
        //we have to remove duplicate options
        options = removeDuplicateObjects(options, "id");
      }

      return {
        name: option?.name,
        kind: "select",
        type: "text",
        label: (
          <Stack
            direction="row"
            alignItems="center"
            justifyContent={"space-between"}
            gap={1}
          >
            <Typography variant="body1">{option?.name}*</Typography>

            <IconButton
              size="small"
              onClick={() => navigate("/products-option-values")}
              sx={{ padding: 0 }}
            >
              <AddIcon fontSize="small" />
              {t("products.action_add_new_value")}
            </IconButton>
          </Stack>
        ),
        placeholder: option?.name,
        width: "100%",
        options: options?.map((item) => ({
          ...item,
          affix: (
            <Stack direction="row" alignItems="center" gap="5px">
              {item?.image ? (
                <Box
                  component="img"
                  src={item?.image}
                  sx={{ width: 15, height: 15, objectFit: "cover" }}
                />
              ) : (
                <Box
                  sx={{
                    width: 15,
                    height: 15,
                    bgcolor: item?.presentation,
                    border: "1px solid gray",
                  }}
                />
              )}
              {item?.image ? null : (
                <Typography variant="body2">{item?.presentation}</Typography>
              )}
            </Stack>
          ),
        })),
        isLoading: option_values_loading?.type === `option value ${option?.id}`,
        onOpen: () => {
          if (
            !option_values[option?.id] ||
            option_values[option?.id]?.list?.length <= 1
          ) {
            // console.log(option_values, id, option_values[id]?.list?.length <= 1, "TEST");
            fetchOptionValues({ page_number: 1 }, option?.id);
          }
        },
        height: "200px",
        count: option_values[option?.id]?.count,
        getList: (filterObj) => fetchOptionValues(filterObj, option?.id),
      };
    });

    return optionTypes;
  };

  const tabs = [
    {
      title: t("products.label_details"),
      children: (
        <VariantDetailsForm
          handleClose={handleClose}
          formik={formik}
          refsubmit={refsubmit}
          optionTypesFilter={optionTypesFilter}
          structure={() => structure(prepareOptionTypes, t)}
        />
      ),
    },
    {
      title: t("vendors.label_locations"),
      children: (
        <AddLocation
          locations={locations}
          setLocations={setLocations}
          handleAddAnotherLocation={handleAddAnotherLocation}
          handleLocationDataChange={handleLocationDataChange}
          handleSaveVariantBranch={handleSaveVariantBranch}
          handleDeleteVariantBranch={handleDeleteVariantBranch}
          branches={branches}
        />
      ),
    },
  ];

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  useEffect(() => {
    if (Object.keys(formik?.errors).length !== 0 && formik?.isSubmitting) {
      const msg = Object.keys(formik?.errors).map(
        (err) =>
          `${
            err == "en"
              ? t("products.placeholder_name_en")
              : err.split("_").join(" ")
          }  ${t("vendors.error_is_required")}`,
      );
      toast.error(msg?.join(", "));
    }
  }, [formik?.errors, formik?.isSubmitting]);

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="add variant"
      aria-describedby="variant details"
    >
      <Box sx={style}>
        <FormHeader
          handleClose={handleClose}
          title={
            id
              ? t("products.breadcrumb_edit_variant")
              : t("products.action_add_variant")
          }
        />
        <Stack sx={{ overflowY: "auto", flexGrow: 1 }}>
          <Loading
            isLoading={
              load?.type == "variantsDetails" ||
              load?.type == "update" ||
              load?.type == "updateVariantBranch" ||
              load?.type == "deleteVariantBranch" ||
              load?.type == "createVariantBranch" ||
              load?.type == "createVariant" ||
              load?.type == "updateVariant"
            }
          >
            <CustomTabs
              tabs={tabs}
              selectedTab={selectedTab}
              handleTabChange={handleTabChange}
              tabstyle={{
                width: "50%",
                fontWeight: "500",
              }}
              selectedTabStyle={{
                color: `${oliveGreen} !important`,
                borderBottom: "1px solid ",
                fontWeight: "600",
              }}
            />
          </Loading>
        </Stack>
      </Box>
    </Modal>
  );
}
